var _excluded = ["label", "secondaryLabel", "statusIcon", "tooltipProps", "badgeProps", "isDisabled", "variant", "size", "isReadOnly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { Group } from '../../../../containers';
import { StatusIconOutlined } from '../../../../foundations/StatusIconOutlined';
import { StatusIconSolid } from '../../../../foundations/StatusIconSolid';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { _IconIndicator, Box } from '../../../internal';
import { Badge } from '../../Badge';
import { Text } from '../../Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private
 */
export var _MainLabel = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    label,
    secondaryLabel,
    statusIcon,
    tooltipProps,
    badgeProps,
    isDisabled,
    variant = 'default',
    size = 'large',
    isReadOnly
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('_MainLabel', {
    variant,
    size
  });
  var labelComponent = label ? /*#__PURE__*/_jsx(Box, {
    __css: styles['label'],
    "aria-disabled": isDisabled,
    "data-readonly": isReadOnly || null,
    children: /*#__PURE__*/_jsx(Text, {
      textStyle: "inline",
      color: "inherit",
      shouldSupportEllipsis: true,
      children: label
    })
  }) : 'placeholder' in props && /*#__PURE__*/_jsx(Box, {
    __css: styles['placeholder'],
    children: /*#__PURE__*/_jsx(Text, {
      color: "inherit",
      textStyle: "inline",
      shouldSupportEllipsis: true,
      children: props.placeholder
    })
  });
  var iconComponent;

  if (tooltipProps) {
    var _tooltipProps$trigger;

    iconComponent = /*#__PURE__*/_jsx(_IconIndicator, {
      tooltip: {
        label: tooltipProps.label,
        title: tooltipProps.title
      },
      "data-testid": "line-item-tooltip-trigger",
      variant: (_tooltipProps$trigger = tooltipProps.triggerStatus) !== null && _tooltipProps$trigger !== void 0 ? _tooltipProps$trigger : 'info'
    });
  } else if (statusIcon) {
    // Warning small icon should always be solid
    if (statusIcon === 'warning') {
      iconComponent = /*#__PURE__*/_jsx(StatusIconSolid, {
        "data-testid": "line-item-icon",
        size: "small",
        variant: statusIcon,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
      });
    } else {
      iconComponent = /*#__PURE__*/_jsx(StatusIconOutlined, {
        "data-testid": "line-item-icon",
        size: "small",
        variant: statusIcon,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
      });
    }
  }

  return /*#__PURE__*/_jsxs(Group, _objectSpread(_objectSpread({
    ref: ref,
    "data-component": "_MainLabel"
  }, props), {}, {
    spacing: "xxs",
    alignItems: "center",
    children: [labelComponent, secondaryLabel && /*#__PURE__*/_jsx(Box, {
      __css: styles['secondaryLabel'],
      "aria-disabled": isDisabled,
      "data-readonly": isReadOnly || null,
      children: secondaryLabel
    }), (tooltipProps || statusIcon) && /*#__PURE__*/_jsx(Box, {
      __css: styles['iconIndicator'],
      "aria-disabled": isDisabled,
      "data-readonly": isReadOnly || null,
      children: iconComponent
    }), badgeProps && /*#__PURE__*/_jsx(Group, {
      spacing: "xxs",
      children: (Array.isArray(badgeProps) ? badgeProps : [badgeProps]).map((badge, i) => /*#__PURE__*/_jsx(Badge, {
        isDisabled: isDisabled,
        status: badge.status,
        label: badge.label,
        type: badge.type,
        isReadOnly: isReadOnly
      }, i))
    })]
  }));
});
_MainLabel.displayName = '_MainLabel';
//# sourceMappingURL=_MainLabel.js.map